(function () {
  function initSection(root) {
    var gap = parseFloat(root.getAttribute('data-gap') || '16');
    var peek = parseFloat(root.getAttribute('data-peek') || '40');
    var autoplaySec = parseFloat(root.getAttribute('data-autoplay') || '0');

    var viewport = root.querySelector('.cs-viewport');
    if (viewport) viewport.style.setProperty('--peek', peek + 'px');

    var swiperEl = root.querySelector('.cs-swiper');
    if (!swiperEl) return;

    var prevEl = root.querySelector('.cs-prev');
    var nextEl = root.querySelector('.cs-next');

    /* global Swiper */
    new Swiper(swiperEl, {
      slidesPerView: 2,
      spaceBetween: gap,
      centeredSlides: false,
      grabCursor: true,
      resistanceRatio: 0.85,
      watchSlidesProgress: true,
      navigation: (prevEl && nextEl) ? { prevEl: prevEl, nextEl: nextEl } : {},
      observer: true,
      observeParents: true,
      loop: true,

      // 👉 carica sempre una slide in più nel loop
      loopAdditionalSlides: 1,

      // ✅ Autoplay: attivo solo se > 0 secondi
      autoplay: autoplaySec > 0 ? {
        delay: Math.max(autoplaySec * 1000, 1000),
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      } : false,

      breakpoints: {
        0:    { slidesPerView: 1 },
        800:  { slidesPerView: 2 },
        1160: { slidesPerView: 3 },
        1920: { slidesPerView: 4 },
        2150: { slidesPerView: 5 }
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.cs-section').forEach(initSection);
  });
})();
